import {
  ArrowLeft,
  Moon,
  Droplets,
  Wind,
  Thermometer,
  ChevronRight,
} from "lucide-react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import welcomeBg from "../../assets/homebg.png";

const HealthVitalsAll = () => {
  const navigate = useNavigate();

  const vitals = [
    {
      icon: Moon,
      label: "Sleep",
      value: "8.5",
      unit: "hrs",
      color: "text-blue-600",
      bgColor: "bg-blue-100",
      route: "/glucera/fitness/sleep",
    },
    {
      icon: Droplets,
      label: "SpO2",
      value: "98",
      unit: "%",
      color: "text-cyan-600",
      bgColor: "bg-cyan-100",
      route: "/glucera/fitness/spo2",
    },
    {
      icon: Wind,
      label: "Breathing Rate",
      value: "14",
      unit: "rpm",
      color: "text-green-600",
      bgColor: "bg-green-100",
      route: "/glucera/fitness/breathing",
    },
    {
      icon: Thermometer,
      label: "Temperature",
      value: "36.8",
      unit: "°C",
      color: "text-orange-600",
      bgColor: "bg-orange-100",
      route: "/glucera/fitness/temperature",
    },
  ];

  return (
    <div
      className="scrollbar-hide relative mx-auto w-full max-w-[400px] bg-white"
      style={{
        backgroundColor: "white !important",
        minHeight: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Blurred Background Image */}
      <div
        className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-md"
        style={{
          backgroundImage: `url(${welcomeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-white/80" />

      <div
        className="scrollbar-hide relative z-10 space-y-4 overflow-y-auto p-4 pb-16"
        style={{ height: "calc(100vh - 0px)" }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/glucera/fitness")}
            className="rounded-xl bg-white/80 hover:bg-white"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-title2 font-bold text-gray-900">Health Vitals</h1>
            <p className="text-caption1 text-gray-600">Your key health metrics</p>
          </div>
        </div>

        <div className="space-y-3">
          {vitals.map((vital, index) => {
            const Icon = vital.icon;
            return (
              <Card
                key={index}
                className="cursor-pointer rounded-2xl border border-gray-100 bg-white p-5 shadow-lg transition-shadow hover:shadow-xl"
                onClick={() => navigate(vital.route)}
              >
                <div className="flex items-center gap-4">
                  <div
                    className={`flex h-14 w-14 items-center justify-center rounded-xl ${vital.bgColor}`}
                  >
                    <Icon className={`h-7 w-7 ${vital.color}`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="mb-1 font-semibold text-gray-900">
                      {vital.label}
                    </h3>
                    <div className="flex items-baseline gap-1">
                      <span className="text-title1 font-bold text-gray-900">
                        {vital.value}
                      </span>
                      <span className="text-subhead text-gray-600">
                        {vital.unit}
                      </span>
                    </div>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-400" />
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HealthVitalsAll;
